import React from 'react';

const ProfileSettings = ({ onEditProfile }) => {
  return (
    <div>
      <h2 style={{ color: '#333', marginBottom: '20px' }}>プロフィール設定</h2>
      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px'
      }}>
        <p>プロフィール設定はダッシュボードから編集できます。</p>
        {/* <button 
          onClick={onBackToDashboard}
          style={{
            backgroundColor: '#ff6b35',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          ダッシュボードに戻る
        </button> */}
        <button 
            onClick={onEditProfile}
            style={{
              backgroundColor: '#ff6b35',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            プロフィール編集
          </button>
      </div>
    </div>
  );
};

export default ProfileSettings; 